import { readCookie, deleteCookie } from "common/utils/cookie";

export type DesignUploadCookieData = {
  id: string;
  url: string;
  original_image_url: string;
  original_mime: string;
  updated_at?: string;
};

export class DesignUploadCookie {
  private static COOKIE_NAME = "upload_design_on_print_plp";

  static read(): DesignUploadCookieData | null {
    const cookieValue = readCookie(this.COOKIE_NAME);
    if (!cookieValue) return null;

    try {
      const decoded = atob(cookieValue);
      return JSON.parse(decoded);
    } catch {
      // Invalid cookie, clean it up
      deleteCookie(this.COOKIE_NAME);
      return null;
    }
  }

  static delete(): void {
    deleteCookie(this.COOKIE_NAME);
  }

  static exists(): boolean {
    return !!this.read();
  }
}
